import React from 'react';
import trans from 'translate';
import { getValueByMultiProps } from '../../../../../../utils/mapper';
import TokenPrice from '../../../../../Common/SliderTokensList/SliderToken/TokenPrice/TokenPrice';
import TokenWithNetwork from '../../../../../Common/TokenWithNetwork/TokenWithNetwork';
import { TooltipedNumber } from '../../../../../Common/TooltipedNumber/TooltipedNumber';
import config from '../../../../../../config/config.json';
import { displayFloats } from '../../../../../../utils/numbersDisplay';

// eslint-disable-next-line
const Cell = ({ title, children, extraTranslate }) => (
  <div className="d-flex flex-column">
    {title && <span className="disabled text-left white-space-pre font-reg">{trans(title, extraTranslate)}</span>}
    <span className="">{children}</span>
  </div>
);

export const editTradeOrders = [
  {
    id: '',
    title: '',
    render: (record) => (
      <div
        className="gap-md d-flex align-items-center"
        style={{
          padding: '0 1rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <TokenWithNetwork
          token={{
            ...record,
            name: getValueByMultiProps(record, ['token_name', 'name']),
            percentage: getValueByMultiProps(record, ['token_ratio', 'percentage']),
            token_id: getValueByMultiProps(record, ['token_id', 'id']),
            network: 'binance',
            image: getValueByMultiProps(record, [
              'image',
              'token_image_thumb',
              'token_image_small',
              'token_image_large',
            ]),
          }}
        />
        <Cell>
          <span className="">{getValueByMultiProps(record, ['token_name', 'name'])}</span>
        </Cell>
      </div>
    ),
  },
  {
    id: 'ratio',
    title: 'Token Percentage',
    render: (record) => (
      <Cell title="hpool.percentage">
        <span className="">
          {`${displayFloats(getValueByMultiProps(record, ['token_ratio', 'percentage', 'current_ratio_from_pool']))}%`}
        </span>
      </Cell>
    ),
  },
  {
    id: 'amount',
    title: 'Token Amount',
    render: (record) => (
      <div className="flex-centered">
        <Cell title="hpool.amount">
          <div className="d-flex">
            <TooltipedNumber number={record?.current_state_amount} show={false} />
            <span className="mx-1">{record?.token_symbol}</span>
          </div>
        </Cell>
      </div>
    ),
  },
  {
    id: 'tokenUsTotal',
    title: '',
    render: (token) => (
      <Cell title="hpool.value">
        <TokenPrice token={token}>
          {({ usdEqValue }) => <span>${displayFloats(usdEqValue * token?.current_state_amount || 0)}</span>}
        </TokenPrice>
      </Cell>
    ),
  },
  {
    id: 'tokenEthTotal',
    title: '',
    render: (token) => (
      <Cell title="hpool.token_value" extraTranslate={{ token: config.baseCoin }}>
        <TokenPrice token={token}>
          {({ usdEqValue, bnbInUsd }) => (
            <span className="white-space-pre">
              {displayFloats((usdEqValue / bnbInUsd) * token?.current_state_amount || 0, 5)}{' '}
              {config.baseCoin.toUpperCase()}
            </span>
          )}
        </TokenPrice>
      </Cell>
    ),
  },
];
